import * as React from "react";

function FmcgSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32.562}
      height={32.562}
      {...props}
    >
      <path
        d="M20.19 20.932h7.964l1.661-2.907h-7.964zm0 0M19.77 22.096h8.141v10.466H19.77zm0 0M29.073 22.096h3.489v10.466h-3.489zm0 0M17.444 0h2.326v1.163h-2.326zm0 0M22.096 15.7h8.141v1.163h-8.141zm0 0M29.494 20.932h2.648l-1.324-2.316zm0 0"
        fill="#ff7b16"
      />
      <path
        d="M23.255 13.508v1.029h-1.744a.581.581 0 00-.581.581v2.169l-2.25 3.937a.653.653 0 00-.076.291v11.047h-4.649V13.514l3.425-6.855a.583.583 0 00.064-.262V2.326h2.326v4.07a.583.583 0 00.064.262zm0 0M12.793 13.955v18.607H4.652V13.955h1.744v2.326h1.163v-2.326zm0 0M.505 32.562h2.479l-1.24-1.859zm0 0M2.984 13.955H.505l1.24 1.859zm0 0"
        fill="#ff7b16"
      />
      <path
        d="M1.744 17.444a.582.582 0 01-.484-.259L0 15.294v15.932l1.261-1.891a.6.6 0 01.968 0l1.261 1.891V15.294l-1.261 1.893a.582.582 0 01-.485.257zm0 0M11.045 5.815a4.612 4.612 0 00-2.326.63 4.643 4.643 0 00-6.974 4.022v2.326h1.163v-2.326a3.485 3.485 0 014.8-3.231 4.634 4.634 0 00-1.312 3.231v2.326h1.163v-2.326a3.477 3.477 0 011.163-2.593 3.477 3.477 0 011.163 2.593v2.326h1.16v-2.326a4.634 4.634 0 00-1.312-3.231 3.481 3.481 0 013.753.738l.814-.83a4.626 4.626 0 00-3.255-1.329zm0 0"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default FmcgSvg;
